<template>
  <v-overlay
    :model-value="overlay"
    class="align-center justify-center"
  >
    <v-progress-circular
      color="primary"
      size="64"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
  <v-row>
    <v-col v-for="(card, i) in wweList" :key="i" cols="12" md="4" sm="8">
      <custom-card
        :disabled="card.disabled"
        :title="card.title"
        :subTitle="card.subTitle"
        :text="card.text"
        :toPath="card.path"
        :color="card.color"
        :cardColor="card.cardColor"
        @startButtonClicked="handleCardClick(card)"
      ></custom-card>
    </v-col>
  </v-row>
</template>

<script>
import CustomCard from '../../components/card/CustomCard.vue';
export default {
  name: 'StartWwe',
  components: { CustomCard },
  data() {
    return {
      overlay: false,
      wweList: [
        {
          title: "WBE-Ref",
          subTitle: "Reference Extraction",
          text: "Extracting Chemical data in wastewater using LLM",
          color: "primary",
          cardColor: "blue-lighten-5",
          path: "/wbe-ref",
          disabled: true
        },
        {
          title: "WBE-Rev",
          subTitle: "Data Review",
          text: "Provide the available WWE information",
          color: "primary",
          cardColor: "green-lighten-5",
          path: "/wbe-rev",
          disabled: true
        },
        {
          title: "WBE-Rank",
          subTitle: "Risk Ranking",
          text: "Ranking the human health risk of various chemicals though their concentration information of the input water of wastewater sample, which can be obtained by extracting the input papers or users uploaded information.",
          color: "primary",
          cardColor: "green-lighten-5",
          path: "/wbe-rank",
          disabled: true
        }
      ]
    };
  },
  methods: {
    handleCardClick(card) {
      if (card.disabled) return;
      this.overlay = true;
      // 跳转到对应路径
      this.$router.push({ path: card.path });
      this.overlay = false;
    }
  }
};
</script>

<style scoped></style>
